module.exports = __webpack_public_path__ + "ec97418b720fede463e742fcbb8869cc.MP3";